import React, { FC } from 'react';
import { AuthenticationContainer } from '@components/organisms/AuthenticationContainer';
import { VerifyAccountCard } from '@components/molecules/authentication/VerifyAccountCard';

export const VerifyAccount: FC = () => {
    return (
        <AuthenticationContainer>
            <VerifyAccountCard />
        </AuthenticationContainer>
    );
};
